import ToastWrapper from '@common/helpers/toastWrapper';
import PaymentsService from '@app/dev/services/payments';
import { TicketHandlers } from '@tickets/helpers/addTicketByType';
import { TerminalTicketTypeEnum } from '@tickets/constants';
import { isMultiDepositModeEnabled } from '@app/dev/helpers/multiDepositMode';


const getTicketPlayerData = async (betId, ticketType) => {
  if (!window.isFromApp || !isMultiDepositModeEnabled()) return null;

  const playersDataRequestModel = [{
    betId,
    source: ticketType
  }]

  const ticketsPlayersData = await PaymentsService.getBetPlayerPaymentInfo(playersDataRequestModel);
  console.log(ticketsPlayersData, 'ticketsPlayerData from getTicketPlayerData')
  const playerData = ticketsPlayersData[0];

  return playerData
}

export const getTickets = async (ticketType, value) => {
  try {
    const data = await TicketHandlers[ticketType](value);
    console.log('herrer')
    const playerData = await getTicketPlayerData(data?.dataFromSwarm?.id || data?.dataFromCasino?.CasinoTransactionId, TerminalTicketTypeEnum[ticketType])
    console.log(data, playerData, 'sdfiomsdoif')
    if (data) return {
      ...data,
      playerData
    };
  } catch {
    ToastWrapper('error', 'something went wrong');
  }
};
